import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import CugsGamesPortal from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignUp';
import LeaderboardPage from './pages/LeaderboardPageWrapped';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<CugsGamesPortal />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/leaderboards" element={<LeaderboardPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;